<template>
    <router-view/>
</template>

<script>
export default {
    name: 'TreasurePage'
}
</script>

<style lang="scss" scoped></style>
